'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dropdown = require('./dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _customSelectLocal = require('./custom-select.local.css');

var _customSelectLocal2 = _interopRequireDefault(_customSelectLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable jsx-a11y/no-static-element-interactions */


var CustomSelectInput = function (_Component) {
  _inherits(CustomSelectInput, _Component);

  function CustomSelectInput(props) {
    _classCallCheck(this, CustomSelectInput);

    var _this = _possibleConstructorReturn(this, (CustomSelectInput.__proto__ || Object.getPrototypeOf(CustomSelectInput)).call(this, props));

    _this.getSelectedOption = function () {
      return _this.props.options.filter(function (x) {
        return x.value === _this.props.value;
      })[0] || {};
    };

    _this.openDropdown = function () {
      _this.setState({
        isOpen: true
      });
    };

    _this.closeDropdown = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.makeSelection = function (value) {
      _this.props.onChange(value);

      _this.closeDropdown();
    };

    _this.state = {
      isOpen: props.defaultOpen || false
    };
    return _this;
  }

  _createClass(CustomSelectInput, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          className = _props.className,
          name = _props.name,
          label = _props.label,
          dropdownClassName = _props.dropdownClassName,
          optionClassName = _props.optionClassName,
          inputClassName = _props.inputClassName,
          options = _props.options,
          icon = _props.icon,
          iconColor = _props.iconColor,
          theme = _props.theme,
          maxDropdownHeight = _props.maxDropdownHeight,
          iconSize = _props.iconSize;
      var selectedOption = this.getSelectedOption();
      var readOnly = options.length <= 1;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_customSelectLocal2.default.wrapper, theme && _customSelectLocal2.default['theme--' + theme], className)
      }, _react2.default.createElement(_label2.default, {
        'data-auto': 'customSelectInput',
        htmlFor: name,
        text: label,
        className: _customSelectLocal2.default.label
      }), _react2.default.createElement('div', {
        className: _customSelectLocal2.default.customSelectInputWrapper
      }, _react2.default.createElement(_text2.default, {
        id: name,
        name: name,
        scope: 'custom-select',
        readOnly: true,
        theme: theme,
        wrapperClassname: _customSelectLocal2.default.customSelectInput,
        className: (0, _classnames2.default)(inputClassName, (_classNames = {}, _defineProperty(_classNames, _customSelectLocal2.default.customSelectTextInput, readOnly), _defineProperty(_classNames, _customSelectLocal2.default.readOnly, readOnly), _classNames)),
        value: selectedOption.label,
        onFocus: this.openDropdown
      }), (icon || selectedOption.icon) && !readOnly && _react2.default.createElement('span', {
        onClick: this.openDropdown
      }, _react2.default.createElement(_icon2.default, {
        id: 'inputIcon',
        icon: icon || selectedOption.icon,
        className: (0, _classnames2.default)(_customSelectLocal2.default.customSelectInputIcon, iconColor === 'currentColor' ? _customSelectLocal2.default.inputIcon : null),
        color: iconColor,
        size: iconSize
      })), this.state.isOpen && _react2.default.createElement(_dropdown2.default, {
        theme: theme,
        id: name + 'Dropdown',
        dropdownClassName: dropdownClassName,
        optionClassName: optionClassName,
        maxDropdownHeight: maxDropdownHeight,
        options: options,
        close: this.closeDropdown,
        selectedOption: selectedOption,
        makeSelection: this.makeSelection
      })));
    }
  }]);

  return CustomSelectInput;
}(_react.Component);

CustomSelectInput.defaultProps = {
  iconColor: 'currentColor',
  maxDropdownHeight: 250
};
CustomSelectInput.propTypes = {
  /**
   * Unique input name
   */
  name: _propTypes2.default.string.isRequired,

  /**
   * Label to be applied to input
   */
  label: _propTypes2.default.string,

  /**
   * Specify an icon to be rendered in the input
   */
  icon: _propTypes2.default.string,

  /**
   * Specify a color for an icon rendered in the input
   */
  iconColor: _propTypes2.default.string,

  /**
   * Specify a size for an icon rendered in the input
   */
  iconSize: _propTypes2.default.string,

  /**
   * Array of dropdown options
   */
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    label: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string,
    className: _propTypes2.default.string,
    iconSize: _propTypes2.default.oneOf(['xsmall', 'small', 'normal', 'medium', 'large']),
    disabled: _propTypes2.default.bool
  })),

  /**
   * Called when a selection is made
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * Should be open by default
   */
  defaultOpen: _propTypes2.default.bool,

  /**
   * Component wrapper classname
   */
  className: _propTypes2.default.string,

  /**
   * Classname of dropdown component
   */
  dropdownClassName: _propTypes2.default.string,

  /**
   * Classname of option within dropdown component
   */
  optionClassName: _propTypes2.default.string,

  /**
   * Classname of input
   */
  inputClassName: _propTypes2.default.string,

  /**
   * Sets the color theme
   */
  theme: _propTypes2.default.oneOf(['classic', 'normal', 'dark']),

  /**
   * Current value, must equal the value of a single option
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Sets the maximum height of dropdown component and `overflow-y: auto`. Prevent
   * this behavior by setting it to `false`.
   */
  maxDropdownHeight: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]).isRequired
};
exports.default = CustomSelectInput;